import { BehaviorSubject, Subject } from "rxjs";
import { FormRendererProps } from "./renderer/form-renderer";

/**
 * App-wide signal: `datasetFormRequest.next(props)` opens a form. Kept in its own
 * module (not the .tsx) so the hosts export only their components — a React Fast
 * Refresh requirement.
 *
 * Two hosts render it: DatasetFormModal (a dialog, the default) and
 * InlineFormHost (a split page's right pane). While an inline host is mounted it
 * claims every request and the dialog stands down, so a form opener never needs
 * to know where it will be drawn.
 */
export const datasetFormRequest = new Subject<FormRendererProps | undefined>();

/** How many InlineFormHosts are mounted; > 0 means forms render inline. */
export const inlineFormHosts = new BehaviorSubject<number>(0);
